{
  "einleitungstext": "Das Begleitmaterial bietet pädagogische Ressourcen für den Unterricht und die außerschulische Bildungsarbeit. Alle Materialien können kostenlos heruntergeladen und verwendet werden.",
  "materialien": [
    {
      "id": 1,
      "titel": "Stolpersteinstadtrundgang HGW",
      "vorschaubild": "img/begleitmaterial/10_Stolpersteinstadtrundgang_HGW.webp",
      "pdf_src": "pdf/10_Stolpersteinstadtrundgang_HGW.pdf",
      "beschreibung": "Dieses Dokument beinhaltet Aufgaben für einen Stadtrundgang durch Greifswald zum Thema Stolpersteine und jüdische Geschichte.",
      "dateigroesse": "0.9 MB"
    },
    {
      "id": 2,
      "titel": "Stolpersteinbroschüre Greifswald",
      "vorschaubild": "img/begleitmaterial/09_Stolpersteinbroschuere_Greifswald.webp",
      "pdf_src": "pdf/09_Stolpersteinbroschuere_Greifswald.pdf",
      "beschreibung": "Die PDF enthält die digitale Stolpersteinbroschüre mit Kurzbiografien und Beschreibungstexten zu Stolpersteinen und Orten jüdischer Geschichte.",
      "dateigroesse": "12.9 MB"
    },
    {
      "id": 9,
      "titel": "Berlin-Tel Aviv (Max Herre)",
      "vorschaubild": "img/begleitmaterial/02_Berlin_Tel_Aviv_Max_Herre.webp",
      "pdf_src": "pdf/02_Berlin_Tel_Aviv_Max_Herre.pdf",
      "beschreibung": "Mehrere Arbeitsblätter zum Song Berlin-Tel Aviv mit der Betrachtung unter verschiedenen Gesichtspunkten wie Textverständnis, Wirkung, historische Einordnung etc.",
      "dateigroesse": "1.6 MB"
    },
    {
      "id": 3,
      "titel": "Biografie Dr. Dagobert Knoche",
      "vorschaubild": "img/begleitmaterial/03_Biografie_Dagobert_Knoche.webp",
      "pdf_src": "pdf/03_Biografie_Dagobert_Knoche.pdf",
      "beschreibung": "Input zum Wissenschaftler Dr. Dagobert Knoche (Stolperstein liegt vor Universitätsgebäude) und die Rolle von Universitäten während des Nationalsozialismus",
      "dateigroesse": "0.4 MB"
    },
    {
      "id": 4,
      "titel": "Biografie Familie Futter",
      "vorschaubild": "img/begleitmaterial/04_Biografie_Familie_Futter.webp",
      "pdf_src": "pdf/04_Biografie_Familie_Futter.pdf",
      "beschreibung": "Das Dokument enthält biografische Fakten zur Familie Futter, die in der Brüggstraße in Greifswald wohnten. ",
      "dateigroesse": "0.7 MB"
    },
    {
      "id": 5,
      "titel": "Das Judentum – Ein Einstieg in die Religion",
      "vorschaubild": "img/begleitmaterial/05_Das_Judentum-ein_Einstieg_in_die_Religion.webp",
      "pdf_src": "pdf/05_Das_Judentum-ein_Einstieg_in_die_Religion.pdf",
      "beschreibung": "Ein Arbeitsblatt zum Judentum mit dem Weiterverweis auf ein Lernvideo zu der Religion. ",
      "dateigroesse": "0.3 MB"
    },
    {
      "id": 6,
      "titel": "Ereignisübersicht und Begriffe des Holocausts",
      "vorschaubild": "img/begleitmaterial/06_Ereignisuebersicht_und_Begriffe_des_Holocausts.webp",
      "pdf_src": "pdf/06_Ereignisuebersicht_und_Begriffe_des_Holocausts.pdf",
      "beschreibung": "Begriffsklärungen und ein Zeitstrahl rund um das Thema Holocaust.",
      "dateigroesse": "0.7 MB"
    },
    {
      "id": 7,
      "titel": "Ich, Du, Wir Themeneinstieg",
      "vorschaubild": "img/begleitmaterial/07_Ich-Du-Wir_Themeneinstieg.webp",
      "pdf_src": "pdf/07_Ich-Du-Wir_Themeneinstieg.pdf",
      "beschreibung": "Arbeitsblatt zur eigenen Identität, wobei die Religion eine Rolle spielt. Mögliche Hinleitung zum Thema Judentum.",
      "dateigroesse": "99 KB"
    },
    {
      "id": 8,
      "titel": "Lückentext Johanna Joel",
      "vorschaubild": "img/begleitmaterial/08_Lueckentext_Joahnna_Joel.webp",
      "pdf_src": "pdf/08_Lueckentext_Joahnna_Joel.pdf",
      "beschreibung": "Lückentext zur Kurzbiografie der Jüdin Johanna Joel, für die ein Stolperstein in Greifswald verlegt wurde.",
      "dateigroesse": "38 KB"
    },
    {
      "id": 10,
      "titel": "Aufgaben zum Ausflug nach Niederhof und Stralsund",
      "vorschaubild": "img/begleitmaterial/01_Aufgaben_zum_Ausflug_nach_Niederhof_und_Stralsund-2.webp",
      "pdf_src": "pdf/01_Aufgaben_zum_Ausflug_nach_Niederhof_und_Stralsund-2.pdf",
      "beschreibung": "Arbeitsaufträge, die in Kleingruppen bei einer Exkursion zum Thema jüdisches Leben Stralsund und jüdischer Friedhof Niederhof eingesetzt werden können.",
      "dateigroesse": "0.9 MB"
    },
    {
      "id": 11,
      "titel": "Suchsel Judentum",
      "vorschaubild": "img/begleitmaterial/11_Suchsel_zum_Judentum.webp",
      "pdf_src": "pdf/11_Suchsel_zum_Judentum.pdf",
      "beschreibung": "Suchsel zu 19 Begriffen des Judentums inklusive Auflösung. ",
      "dateigroesse": "2.5 MB"
    }
  ]
}
